/* tslint:disable */
/* eslint-disable */
export enum MergeUserConflictType {
  SameUser = 'same_user',
  InumisIdAlreadyInUse = 'inumis_id_already_in_use',
  TargetUserAlreadyHasPrimaryBidderForAuction = 'target_user_already_has_primary_bidder_for_auction',
  TargetUserAlreadyHasAConsignerForAuction = 'target_user_already_has_a_consigner_for_auction',
  SourceUserHasPendingVerification = 'source_user_has_pending_verification'
}
